import { themeObject, validationsMessages } from 'lib';
import { FieldMappingIcon } from '../../../../assets';
import * as yup from 'yup';
import {
    FieldNameTypeDefaults,
    FieldNameTypeFormValues,
    FieldNameTypeSchema,
} from '../components/field-name-type-helper';

export interface FieldMappingFormValues extends FieldNameTypeFormValues {
    inboundName: string;
}

export const CreateFieldMappingDefaults: FieldMappingFormValues = {
    inboundName: '',
    ...FieldNameTypeDefaults,
};

export const CreateFieldMappingSchema = yup
    .object({
        inboundName: yup.string().required(validationsMessages.required),
    })
    .concat(FieldNameTypeSchema);

export const createFieldMappingConfig: {
    [key: string]: {
        imgSrc: string;
        headingText?: string;
        iconStyles?: React.CSSProperties;
    };
} = {
    'field-mapping': {
        imgSrc: FieldMappingIcon,
        headingText: 'New Field Mapping',
        iconStyles: { display: 'none' },
    },
};

export const createFieldMappingStyles = {
    formFieldHeight: {
        '& .MuiFormControl-root': {
            '& .MuiInputBase-root': {
                height: '38px',
                '& .MuiInputBase-input': {
                    height: '100%',
                },
            },
        },
    },
    formFeatureNextButtonStyles: {
        '& .MuiButtonBase-root': {
            height: '42px !important',
            width: '130px',
        },
    },
    divider: {
        width: '100%',
        mt: 2,
        weight: '1px',
        borderColor: themeObject.palette.grayScale[200],
    },
    noOptionStateStyles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        textAlign: 'center',
        p: '62.5px 0',
    },
    noOptionStateHeading: {
        ...themeObject.typography.h3,
        color: themeObject.palette.primary[700],
    },
};
